import type { PendingReviewOrder } from '../model/types';

export interface ReviewOrderEventParams {
  order_id: number;
  experience_id?: number;
  guide_id?: number;
}

/**
 * Собирает общие параметры sogu-событий блока/попапа отзывов из заказа.
 */
export const buildReviewOrderEventParams = (order: PendingReviewOrder): ReviewOrderEventParams => ({
  order_id: order.id,
  experience_id: order.experience?.id,
  guide_id: order.guide?.id,
});
